<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h1 class="text-center">Impressão de Atendimentos</h1>
      <div v-if="!loadingAtendimentos">
        <button @click="print()" class="btn btn-success btn-sm ml-4" v-if="AtendimentosList.length > 0">Imprimir</button>
        <button class="btn btn-default" @click="voltar()">Voltar</button>
      </div>
    </div>
    <load v-if="loadingAtendimentos" message="Carregando Atendimentos da Família" />
    <div v-else-if="showErrorMessage" class="text-center py-5">
      <div class="alert alert-warning" role="alert">
        <i class="fas fa-exclamation-triangle fa-2x mb-3"></i>
        <h4>{{ errorTitle }}</h4>
        <p>{{ errorMessage }}</p>
        <button class="btn btn-primary mt-2" @click="voltar()">
          <i class="fas fa-arrow-left"></i> Voltar
        </button>
      </div>
    </div>
    <div v-else id="boxPrint" class="col-12 px-0">
      <print-content>
        <table
          v-for="item in AtendimentosList"
          class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
        >
          <tbody>
            <tr>
              <td colspan="1">
                ID: <strong>{{ item.id }}</strong>
              </td>
              <td colspan="2">
                PROTOCOLO: <strong>{{ item.protocolo }}</strong>
              </td>
              <td>
                <span class="small">
                  ATENDIMENTO:
                  <strong v-if="item.data_cadastro">{{
                    item.data_cadastro_formatado
                  }}</strong>
                  <br />
                  CADASTRADO:
                  <strong>{{ item.cadastrado }}</strong>
                </span>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                USUÁRIO(S) ATENDIDO(S):
                <strong
                  class="mr-2"
                  v-for="(pessoa, _) in item.pessoas_objetos"
                  :key="pessoa.id"
                >
                  <span v-if="pessoa.nome_social">{{
                    pessoa.nome_social
                  }}</span>
                  <span v-else> {{ pessoa.nome_completo }} </span>
                  
                </strong>
                <small
                  class="text-muted"
                  v-if="
                    item.familia_id.rf_situacao_rua != null &&
                    item.familia_id.status == 1
                  "
                  ><br />RF registrado em Situação de Rua no Sistema</small
                >
              </td>
            </tr>
            <tr v-if="item.responsavel">
              <td colspan="2">
                TÉCNICO RESPONSÁVEL: <b v-if="item.responsavel.name">{{
                  item.responsavel.name
                }}</b>
              </td>
              <td colspan="2">
                NÚMERO DE REGISTRO PROFISSIONAL:
                <b v-if="item.responsavel.tecnico.numero_registro">{{
                  item.responsavel.tecnico.numero_registro
                }}</b>
                <b v-else>N/A</b>
              </td>
            </tr>
            <tr v-else>
              <td colspan="4">
                TÉCNICO RESPONSÁVEL: <b>N/A</b>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                UNIDADE:
                <b v-if="item.unidade">{{ item.unidade.nome }}</b>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                TÉCNICO AUTOR:
                <b>{{ item.autor }}</b>
              </td>
            </tr>
            
            <tr>
              <td colspan="2">
                TIPO DE ATENDIMENTO: <b>{{ item.tipo }}</b>
              </td>
              <td>
                STATUS:
                <strong v-html="item.status_nome"></strong>
              </td>
              <td>
                SIGILO:
                <b>{{ item.privado == "1" ? "Sim" : "Não" }}</b>
              </td>
            </tr>
            
            <tr v-if="item.tipo == 'ABORDAGEM SOCIAL'">
              <td :colspan="item.outra_situacao_abordagem_social ? '2' : '4'">
                SITUAÇÕES IDENTIFICADAS NA ABORDAGEM SOCIAL:<br />
                <strong
                  v-html="item.situacao_abordagem_social_nomes"
                ></strong>
              </td>
              <td v-if="item.outra_situacao_abordagem_social" colspan="2">
                OUTRAS SITUAÇÕES IDENTIFICADAS:<br />
                <strong
                  v-html="item.outra_situacao_abordagem_social"
                ></strong>
              </td>
            </tr>
            <tr>
              <td colspan="4">
                DESCRIÇÃO SUMÁRIA DO ATENDIMENTO:
                <div v-html="item.descricao_sumaria"></div>
              </td>
            </tr>
            <template v-if="item.historico_remanejamento.length > 0">
              <tr>
                <td colspan="4">HISTÓRICO REMANEJAMENTO:</td>
              </tr>
              <tr>
                <td colspan="2">Data</td>
                <td colspan="2">Motivo</td>
              </tr>
              <tr
                v-for="(historico, index) in item.historico_remanejamento"
                :key="index"
              >
                <td colspan="2">{{ historico.created_at }}</td>
                <td colspan="2">{{ historico.motivo }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </print-content>

      <div class="row align-items-center no-print">
        <div class="col-lg-6 col-md-12">
          <div class="form-group d-inline-flex mb-0">
            <select
              class="form-control"
              style="width: 70px"
              v-model="perPage"
              v-on:change="gerarImpressao"
            >
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="25">25</option>
              <option value="30">30</option>
            </select>
          </div>
          <div class="d-inline-flex ml-2">
            <b-pagination
              :per-page="perPage"
              :total-rows="pagination.total"
              @change="changePage"
              v-model="page"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
          <div class="float-lg-right">
            {{ $t("Showing page") }}
            {{ pagination.currentPage }}
            de
            {{ pagination.totalPages }}
            {{ $t("pages in") }}
            {{ pagination.total }}
            {{ $t("records") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpressaoAtendimentos',
  props: {
    familia_id: {
      type: Number,
      default: null
    },
    filtroStatus: {
      type: String,
      default: null
    },
    filtroDatas: {
      type: String,
      default: null
    },
    filtroDatasAt: {
      type: String,
      default: null
    },
    filtroFamiliar: {
      type: String,
      default: null
    },
    filtroTipos: {
      type: String,
      default: null
    },
    morph: {
      type: null,
      id: null,
    }
  },
  data() {
    return {
      showImpressoaAtendimentos: false,
      loadingAtendimentos: true,
      AtendimentosList: [],
      showErrorMessage: false,
      errorTitle: '',
      errorMessage: '',
      page: 1,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
      perPage: 10,
    }
  },
  mounted() {
    this.gerarImpressao();
  },
  methods: {
    gerarImpressao() {
      this.showImpressoaAtendimentos = true;
      this.loadingAtendimentos = true;

      const params = {
        id: this.familia_id,
        page: this.page,
        perPage: this.perPage,
      }

      if (this.morph && this.morph.id && this.morph.type) {
        params.morph_id = this.morph.id;
        params.morph_type = this.morph.type;
      }

      if (this.filtroStatus) {
        params.filtroStatus = this.filtroStatus;
      }

      if (this.filtroDatas) {
        params.filtroDatas = this.filtroDatas;
      }

      if (this.filtroDatasAt) {
        params.filtroDatasAt = this.filtroDatasAt;
      }

      if (this.filtroFamiliar) {
        params.filtroFamiliar = this.filtroFamiliar;
      }

      if (this.filtroTipos) {
        params.filtroTipos = this.filtroTipos;
      }
      
      axios
        .get("api/dashboard/atendimentos/impressao", {
          params: params,
        })
        .then((response) => {
          this.loadingAtendimentos = false;

          if (response.data && response.data.data && response.data.data.data && response.data.data.data.length > 0) {
            this.AtendimentosList = response.data.data.data;
          } else {
            this.AtendimentosList = [];
          }

          this.pagination = response.data.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.gerarImpressao();
          } else {
            this.loadingAtendimentos = false;
          }
        })
        .catch((error) => {
          console.error("Erro ao carregar atendimentos para impressão");
          this.loadingAtendimentos = false;
          this.showErrorMessage = true;

          if (error.response) {
            switch (error.response.status) {
              case 401:
                this.errorTitle = 'Acesso Negado';
                this.errorMessage = 'Você não tem permissão para visualizar estes atendimentos.';
                break;
              case 403:
                this.errorTitle = 'Permissão Insuficiente';
                this.errorMessage = 'Você não possui as permissões necessárias para acessar este recurso.';
                break;
              case 404:
                this.errorTitle = 'Não Encontrado';
                this.errorMessage = 'Os atendimentos solicitados não foram encontrados.';
                break;
              case 500:
                this.errorTitle = 'Erro do Servidor';
                this.errorMessage = 'Ocorreu um erro interno. Tente novamente em alguns instantes.';
                break;
              default:
                this.errorTitle = 'Erro ao Carregar';
                this.errorMessage = error.response.data?.message || 'Não foi possível carregar os atendimentos.';
            }
          } else if (error.request) {
            this.errorTitle = 'Erro de Conexão';
            this.errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
          } else {
            this.errorTitle = 'Erro Inesperado';
            this.errorMessage = 'Ocorreu um erro inesperado. Tente novamente.';
          }
        });
    },
    voltar() {
      this.showImpressoaAtendimentos = false;
      this.$emit('voltar');
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.gerarImpressao();
      }
    },
  }
}
</script>